export const customerTypes = {
  GET_SUBSCRIPTIONS_REQUEST: "GET_SUBSCRIPTIONS_REQUEST",
  GET_SUBSCRIPTIONS_SUCCESS: "GET_SUBSCRIPTIONS_SUCCESS",
  GET_SUBSCRIPTIONS_FAILURE: "GET_SUBSCRIPTIONS_FAILURE",

  CANCEL_SUBSCRIPTION_REQUEST: "CANCEL_SUBSCRIPTION_REQUEST",
  CANCEL_SUBSCRIPTION_SUCCESS: "CANCEL_SUBSCRIPTION_SUCCESS",
  CANCEL_SUBSCRIPTION_FAILURE: "CANCEL_SUBSCRIPTION_FAILURE",

  GET_PAYMENT_METHODS_REQUEST: "GET_PAYMENT_METHODS_REQUEST",
  GET_PAYMENT_METHODS_SUCCESS: "GET_PAYMENT_METHODS_SUCCESS",
  GET_PAYMENT_METHODS_FAILURE: "GET_PAYMENT_METHODS_FAILURE",

  POST_PAYMENT_METHOD_REQUEST: "POST_PAYMENT_METHOD_REQUEST",
  POST_PAYMENT_METHOD_SUCCESS: "POST_PAYMENT_METHOD_SUCCESS",
  POST_PAYMENT_METHOD_FAILURE: "POST_PAYMENT_METHOD_FAILURE",
};
